import type { ReactNode } from 'react';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { DASHBOARD_LABELS as LABELS } from '../../../utils/labels';

interface ChartCardProps {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  isEmpty: boolean;
  onDownload?: () => void;
  downloadLoading?: boolean;
  downloadLabel?: string;
  testId: string;
}

export default function ChartCard({
  title,
  icon,
  children,
  isEmpty,
  onDownload,
  downloadLoading,
  downloadLabel,
  testId,
}: ChartCardProps) {
  return (
    <div className="bg-surface border border-border rounded-xl p-5" data-testid={testId}>
      <div className="flex items-center justify-between gap-2 mb-0">
        <h2 className="text-base flex items-center gap-2 font-semibold">
          {icon}
          {title}
        </h2>
        {onDownload && (
          <Tooltip title={downloadLabel ?? ''}>
            <span>
              <IconButton
                onClick={onDownload}
                disabled={downloadLoading}
                aria-label={downloadLabel}
                data-testid="download-button"
              >
                {downloadLoading ? (
                  <CircularProgress size="1rem" />
                ) : (
                  <DownloadIcon fontSize="small" />
                )}
              </IconButton>
            </span>
          </Tooltip>
        )}
      </div>
      {isEmpty ? (
        <p className="text-text-secondary text-sm py-8 text-center">{LABELS.noData}</p>
      ) : (
        children
      )}
    </div>
  );
}
